module.exports = "/_next/static/images/c5826abc7292df4f1c8804f4fbeb0b74-medium-fastcompany.png";